// import { Button } from "../../Atoms/Button";
// import capacity from "../../Assets/products_landing/capacity.svg";
import simulator from '../../Assets/products_landing/simulator_side-c.webp';
import bgRing from '../../Assets/home/product_carousel/circle.svg';
import { Button } from '../../Atoms';
import { useState } from 'react';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';

// doc

import FormModal from './FormModal';


export default function ACChargerFlex() {
  let activeIdx = 0;
  const tabData = [
    {
      title: 'Type 2 EV Simulator',
      desc: 'VerdeMobility’s Type 2 EV Simulator is an innovation enabling on-field troubleshooting of EVSEs, on-the-move!',
      availFrom: 0,
      availTo: false,
      fileLink: "https://resources.verdemobility.com/files/VerdeMobilityEVSimulator.pdf",
      imgSrc: simulator,
    },
  ];

  const [productTitle, setProductTitle] = useState("");


  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {

    setIsModalOpen(true)
  };
  return (
    <>
      <section className="flex lg:flex-row flex-col-reverse gap-3 blade-margin-top-sm relative gap-y-6 bg-light-gradient">
        <div className=" basis-32  xl:basis-20 grow shrink  col-end-7 flex items-center  lg:justify-end px-3 pl-5 lg:pl-20 xl:pl-10">
          <div className="basis-72 mr-0 xl:mr-20 grow shrink  max-w-lg  flex flex-col md:gap-4 xl:gap-4">
            <span className="xxl:text-[48px] xl:text-[40px] lg:text-[40px] md:text-[36px] text-[32px] xl:leading-tight lg:leading-tight md:leading-tight leading-tight font-gilroy font-semibold">
              {tabData[activeIdx].title}
            </span>

            <p className="font-poppins font-light mt-2  text-base  md:text-xl  xl:text-2xl lg:max-w-screen-sm max-w-xl">
              {tabData[activeIdx].desc}
            </p>
            <div className="flex items-center py-2 sm:py-3 gap-3">
              <div onClick={() => {
                openModal()
                setProductTitle(tabData[activeIdx].title)
              }}>
                {/* <Button
                  title="Contact Us"
                  className="mt-4"
                /> */}
                <button
                  className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                >
                  <span className="flex justify-center items-center">
                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                  </span>
                  Contact Us
                </button>
              </div>
              <div className='group cursor-pointer'>
                <a href="https://resources.verdemobility.com/files/VerdeMobilityEVSimulator.pdf" target="_blank" className='text-gray-600'>
                  <button
                    className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                  >
                    <span className="flex justify-center items-center">
                      <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                      <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                    </span>
                    Brochure
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="basis-80 grow shrink flex justify-center items-center relative min-h-[300px] sm:min-h-[400px] md:min-h-[550px] lg:min-h-[650px] xxl:min-h-[800px]">
          <div className="absolute top-0 left-auto bottom-0 right-0 bg-gradient w-32 md:w-56 lg:w-80"></div>
          <div className="mx-3 md:w-10/12  md:max-w-[850px] max-w-sm grid place-content-center md:px-10 lg:px-20  bg-grey z-10 h-5/6 lg:h-4/5 rounded-3xl overflow-hidden relative ">
            {/* <div className="object-contain absolute top-20 left-20 bottom-20 right-20">
              <img
                loading="lazy"
                src={bgRing}
                alt="presentational mockup for verdemobility product"
                className=" w-9/12 mx-auto h-full object-center object-contain"
              />
            </div> */}
            <img
              loading="lazy"
              src={tabData[activeIdx].imgSrc}
              alt={tabData[activeIdx].title}
              className="mx-auto my-auto object-contain object-center lg:mb-10 z-10"
            />
          </div>
        </div>
      </section>
      {isModalOpen && <FormModal isModalOpen={isModalOpen} productTitle={productTitle} setIsModalOpen={setIsModalOpen} />}
    </>
  );
}
